import {Offer} from "types/Offer";
import {dateTime, duration} from "services/date";

export function deserializeOffer(offer: any): Offer {
    offer.valid_at       = offer.valid_at? dateTime(offer.valid_at) : null
    offer.valid_for      = duration(offer.valid_for)
    offer.expires_at     = dateTime(offer.expires_at)
    offer.last_issued_at = dateTime(offer.last_issued_at)
    offer.created_at     = dateTime(offer.created_at)
    offer.updated_at     = dateTime(offer.updated_at)

    return offer
}